module.exports = __webpack_public_path__ + "files/SPIADI2026 - BACT ADI+ - Fiche.8b659b94baa5ecef573edef5faecd1e6.pdf";